import { ViewWorkDataQuestion } from './../../../../Elearning-Models';
import { Component, EventEmitter, OnInit, Output, } from '@angular/core';
import { Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { FilterQuestionsService } from 'src/app/Services/filter-questions.service';

@Component({
  selector: 'app-essay',
  templateUrl: './essay.component.html',
  styleUrls: ['./essay.component.scss']
})
export class EssayComponent implements OnInit {
  @Input() question: ViewWorkDataQuestion;
  @Input() isConsumerCurriculum: boolean;
  @Output() gradeChanges: EventEmitter<any> = new EventEmitter<any>();
  filterSubscription: Subscription;
  filterValue: string;
  rubricVisible: boolean = false;
  availableResponseState: boolean = false;
  correct: boolean;

  constructor(
    private filterQuestionsService: FilterQuestionsService
  ) {}

  ngOnInit(): void {
    this.filterSubscription = this.filterQuestionsService.currentFilterValue.subscribe(
      (filterValue) => {
        this.filterValue = filterValue;
      }
    );
  }                                                                                                                                                                                                                                                                                                                                                                                                                                                                        

  gradeStatusChanged = (gradeFormValue) => {
    this.filterValue='';
    switch (gradeFormValue.grade) {
      case "notGraded" : {
        this.question.PointsEarned = null;
        this.correct = null;
        break;
      }
      case "incorrect" : {
        this.question.PointsEarned = 0;
        this.correct = false;
        break;
      }
      case "correct" : {
        this.question.PointsEarned = this.question.PointsAvailable;
        this.correct = true;
        break;
      }
      case "partialCredit" : {
        this.question.PointsEarned = gradeFormValue.partialCredit;
        this.correct = true;
        break;
      }
    }
    this.gradeChanges.emit(this.question);
  }

  partialCreditChanged = (partialCredit) => {
    this.filterValue='';
    this.question.PointsEarned = partialCredit.partialCredit;
    this.gradeChanges.emit(this.question);
  }

  toggleCorrectAnswer = (correctAnswer: HTMLElement, studentResponse: HTMLElement) => {
    this.rubricVisible = !this.rubricVisible;
    if(this.availableResponseState) {
      correctAnswer.style.right = "-55%";
      studentResponse.style.width = "96%";
      document.getElementById('response'+this.question.SequenceNumber.toString()).style.minHeight = "0px";
    } else {
      correctAnswer.style.right = "0";
      studentResponse.style.width = "48%";
      document.getElementById('response'+this.question.SequenceNumber.toString()).style.minHeight = document.getElementById('answer'+this.question.SequenceNumber.toString()).clientHeight + "px";
    }
    this.availableResponseState = !this.availableResponseState;
  }
}

